var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelationship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 411 411",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.015.244h410v410h-410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.904 132.262h83.826a28.402 28.402 0 0 1 15.772 4.779l35.499 23.666V54.04c0-7.851-6.372-14.222-14.222-14.222H229.89c-7.851 0-14.222 6.371-14.222 14.222v64c.014 7.851 6.385 14.222 14.236 14.222Z",
    style: {
      fill: "#f3f3f1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.571,
    cy: 242.484,
    r: 32,
    style: {
      fill: "#f3f3f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.015 359.818v-21.334c0-15.715 12.729-28.444 28.445-28.444h78.222c15.715 0 28.444 12.729 28.444 28.444v21.334H45.015Z",
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.46,
    cy: 242.484,
    r: 32,
    style: {
      fill: "#f3f3f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.904 359.818v-21.334c0-15.715 12.729-28.444 28.444-28.444h78.223c15.715 0 28.444 12.729 28.444 28.444v21.334H229.904ZM208.571 160.707H96.3a28.412 28.412 0 0 0-15.772 4.778l-35.513 23.666V82.484c0-7.85 6.372-14.222 14.222-14.222h149.334c7.85 0 14.222 6.372 14.222 14.222v64c0 7.851-6.372 14.223-14.222 14.223Z",
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46 82.484c0-7.85 6.371-14.222 14.222-14.222H59.237c-7.85 0-14.222 6.372-14.222 14.222v106.667l28.445-18.958V82.484Z",
    style: {
      fill: "#dcb400",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.126 118.04v-64c0-7.851 6.372-14.222 14.222-14.222h-28.444c-7.851 0-14.222 6.371-14.222 14.222v64c0 7.851 6.371 14.222 14.222 14.222h28.444c-7.85 0-14.222-6.371-14.222-14.222ZM357.961 137.041a28.474 28.474 0 0 0-15.773-4.779h-28.444a28.4 28.4 0 0 1 15.772 4.779l35.499 23.666v-18.959l-7.054-4.707ZM109.015 242.484c0-12.544 7.282-23.281 17.778-28.529-4.295-2.148-9.088-3.471-14.222-3.471-17.679 0-32 14.322-32 32 0 17.679 14.321 32 32 32 5.134 0 9.927-1.322 14.222-3.47-10.496-5.248-17.778-16-17.778-28.53ZM293.904 242.484c0-12.544 7.282-23.281 17.778-28.529-4.295-2.148-9.088-3.471-14.222-3.471-17.679 0-32 14.322-32 32 0 17.679 14.321 32 32 32 5.134 0 9.927-1.322 14.222-3.47-10.496-5.248-17.778-16-17.778-28.53Z",
    style: {
      fill: "#d5dbe1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 310.04H73.46c-15.716 0-28.445 12.729-28.445 28.444v21.334H73.46v-21.334c0-15.715 12.728-28.444 28.444-28.444ZM286.793 310.04h-28.445c-15.715 0-28.444 12.729-28.444 28.444v21.334h28.444v-21.334c0-15.715 12.729-28.444 28.445-28.444Z",
    style: {
      fill: "#dcb400",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.015 171.373c-2.076 0-4.124-.597-5.916-1.792L323.6 145.916a17.65 17.65 0 0 0-9.856-2.987h-83.84c-13.724 0-24.889-11.165-24.889-24.889v-64c0-13.724 11.165-24.889 24.889-24.889h120.889c13.724 0 24.889 11.165 24.889 24.889v106.667c0 3.925-2.162 7.537-5.632 9.401a10.584 10.584 0 0 1-5.035 1.265ZM229.904 50.484a3.557 3.557 0 0 0-3.556 3.556v64a3.557 3.557 0 0 0 3.556 3.556h83.84a38.971 38.971 0 0 1 21.689 6.57l18.915 12.615V54.04a3.556 3.556 0 0 0-3.555-3.556H229.904Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.015 199.818c-1.735 0-3.456-.413-5.035-1.266a10.675 10.675 0 0 1-5.632-9.401V82.484c0-13.724 11.165-24.888 24.889-24.888h151.257v21.333H59.237c-1.934 0-3.555 1.621-3.555 3.555v86.784l18.986-12.615c6.258-4.295 13.81-6.613 21.689-6.613h112.214v21.333H96.357c-3.513 0-6.969 1.053-9.77 2.959L50.903 198.04a10.597 10.597 0 0 1-5.888 1.778Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.949 120.145 21.333 8.562v17.777c0 13.725-11.164 24.889-24.889 24.889H110.727V150.04h106.666c1.935 0 3.556-1.621 3.556-3.556v-26.339ZM112.571 285.151c-23.524 0-42.667-19.143-42.667-42.667 0-23.523 19.143-42.666 42.667-42.666 23.523 0 42.666 19.143 42.666 42.666 0 23.524-19.143 42.667-42.666 42.667Zm0-64c-11.762 0-21.334 9.572-21.334 21.333 0 11.762 9.572 21.334 21.334 21.334 11.761 0 21.333-9.572 21.333-21.334 0-11.761-9.572-21.333-21.333-21.333Z",
    style: {
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.368 371.336v-32.818c0-21.575 17.536-39.111 39.111-39.111h78.222c21.575 0 39.111 17.536 39.111 39.111v32.818a10.001 10.001 0 0 1-10 10H44.368a9.997 9.997 0 0 1-10-10Zm135.111-11.373H55.701v-21.445c0-9.799 7.979-17.778 17.778-17.778h78.222c9.799 0 17.778 7.979 17.778 17.778v21.445Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.46 285.151c-23.524 0-42.667-19.143-42.667-42.667 0-23.523 19.143-42.666 42.667-42.666 23.523 0 42.666 19.143 42.666 42.666 0 23.524-19.143 42.667-42.666 42.667Zm0-64c-11.762 0-21.334 9.572-21.334 21.333 0 11.762 9.572 21.334 21.334 21.334 11.761 0 21.333-9.572 21.333-21.334 0-11.761-9.572-21.333-21.333-21.333Z",
    style: {
      fillRule: "nonzero"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.237 371.336v-32.818c0-21.575 17.536-39.111 39.111-39.111h78.223c21.575 0 39.111 17.536 39.111 39.111v32.818a10.001 10.001 0 0 1-10 10H229.237a9.999 9.999 0 0 1-10-10Zm135.111-11.373H240.571v-21.445c0-9.799 7.978-17.778 17.777-17.778h78.223c9.799 0 17.777 7.979 17.777 17.778v21.445Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.d4c7a97fb58d78394a2470f1a6f51bed.svg";
export { ForwardRef as ReactComponent };